const OFFICIAL_ACCOUNT_LINK_ERROR_CODES = new Set([
  'social_media_not_owned',
  'social_connection_required',
  'social_connection_reconnect_required',
]);

export function graphqlErrorCode(message: string | undefined | null): string | null {
  if (!message) return null;
  const code = message.replace(/^.*?:\s*/, '').trim();
  return code || null;
}

export function promptsOfficialAccountLink(code: string | null | undefined): boolean {
  return OFFICIAL_ACCOUNT_LINK_ERROR_CODES.has(String(code || ''));
}

export function ownedConnectionFromOwnershipResult(result: {
  data?: {
    resolveMyCpmOwnedMedia?: { social_connection_id?: string | null } | null;
  } | null;
  error?: { message?: string } | null;
  errors?: ReadonlyArray<{ message?: string }>;
}): { socialConnectionId: string | null; errorCode: string | null } {
  // Apollo 3 lazy-query promises with errorPolicy: 'all' can expose only
  // `errors`, even when the hook's rendered state has an Apollo `error`.
  const errorCode = graphqlErrorCode(result.error?.message)
    || result.errors?.map((error) => graphqlErrorCode(error.message)).find(Boolean);
  if (errorCode) {
    return { socialConnectionId: null, errorCode };
  }
  const socialConnectionId = result.data?.resolveMyCpmOwnedMedia?.social_connection_id || null;
  if (!socialConnectionId) {
    return { socialConnectionId: null, errorCode: 'generic' };
  }
  return { socialConnectionId, errorCode: null };
}
